import {useParams} from 'react-router-dom'
import {Space} from 'antd'
import styles from './ControllerReview.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {
  Block,
  Text,
  Button,
  Modal,
  UserAvatar,
  ThumbsUpCircleIcon,
  DeclineCircleIcon,
} from 'common/components'
import {formatDate} from 'common/helpers'
import {ControllerReviewForm, getMilestone} from '..'
import {useGetDefaultRequest} from '../api.default'

interface ReviewProps {
  milestone: any
}

export default function DefaultReview() {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const params = useParams()
  const {data: request} = useGetDefaultRequest(params.uuid)
  const isControllerReviewOpen = useStore(
    (state) => state.isControllerReviewOpen
  )
  const setControllerReviewOpen = useStore(
    (state) => state.setControllerReviewOpen
  )

  const handleReviewOpen = () => setControllerReviewOpen(true)
  const handleReviewClose = () => setControllerReviewOpen(false)
  const milestone = getMilestone('financial-reviewed', request.milestones)

  return (
    <>
      <Block type="white">
        { milestone?.passed ? (
          <Review milestone={milestone} />
        ) : (
          <div className={styles.block}>
            <Title />
            { !!permissions?.includes('edit default request (fc check)') &&
              (request.status === 'financial-controller-check') &&
              <Button variant="secondary" onClick={handleReviewOpen}>
                add
              </Button>
            }
          </div>
        )}
      </Block>
      <Modal
        title="Financial Controller review"
        width={486}
        open={isControllerReviewOpen}
        onCancel={handleReviewClose}
      >
        <ControllerReviewForm
          requestUuid={request.uuid}
          milestone={milestone}
          onClose={handleReviewClose}
        />
      </Modal>
    </>
  )
}

const Title = () => (
  <Text as="h4" weight="demiBold">
    Financial Controller review
  </Text>
)

const Review = ({milestone}: ReviewProps) => {
  const [type] = milestone?.properties ?? []

  return (
    <>
      <div className={styles.header}>
        <Title />
      </div>
      <div className={styles.content}>
        <Space>
          {type === 'confirm' ? <ThumbsUpCircleIcon /> : <DeclineCircleIcon />}
          <Text size="4xl">{type || 'confirm'}</Text>
        </Space>
        <div className={styles.review}>
          <Text size="sm">
            {milestone.note || milestone.notes || ''}
          </Text>
          <UserAvatar
            className={styles.avatar}
            size={48}
            src={''}
            alt={'name'}
          />
        </div>
        <Text size="2xs" weight="medium" color="grey">
          {formatDate(milestone?.updatedAt || '2020-11-09')}
        </Text>
      </div>
    </>
  )
}
